module.exports = __webpack_public_path__ + "img/logo-15.a0750a8c.png";